import $i18n from 'panda-i18n';
import React from 'react';
import { CnListItem } from '@/components/cn-list';
import classNames from 'classnames';
import { CnPopover } from '@/components/cn-popover';
import { CnButton } from '@/components/cn-button';
const CnEmployeeItem = (props) => {
    const { name = '', nickName = '', workNo, personalPhotoUrl, prefix = 'cn-ui-m-', department, dingtalkProfileUrl, dingding, } = props.data;
    const clsPrefix = `${prefix}employee-item`;
    if (props.mini) {
        const showName = `${name}${nickName ? `(${nickName})` : ''}`;
        const hasDingtalk = dingtalkProfileUrl || dingding;
        const buttonText = hasDingtalk
            ? $i18n.get({
                id: 'DingTalkContact',
                dm: '钉钉联系',
                ns: 'CnEmployeeSelect',
            })
            : $i18n.get({
                id: '37329441080348672.CNTM',
                dm: '阿里内外',
                ns: 'CnEmployeeSelect',
            });
        const buttonHref = hasDingtalk
            ? dingtalkProfileUrl ||
                `dingtalk://dingtalkclient/action/sendmsg?dingtalk_id=${dingding}`
            : `https://work.alibaba-inc.com/nwpipe/u/${workNo}`;
        const cardContent = (React.createElement("div", { className: `${clsPrefix}-popover` },
            React.createElement("div", { className: `${clsPrefix}-popover-body` },
                React.createElement(CnListItem, { title: `${name}${nickName ? `(${nickName})` : ''}`, media: React.createElement("img", { src: personalPhotoUrl, className: `${clsPrefix}-avatar` }), subTitle: `${workNo}` }),
                React.createElement("div", { className: `${clsPrefix}-popover-department` }, department)),
            React.createElement("div", { className: `${clsPrefix}-popover-footer` },
                React.createElement(CnButton, { type: "secondary", component: "a", href: buttonHref, target: "_blank" }, buttonText))));
        return (React.createElement(CnPopover, { content: cardContent, trigger: "click", placement: "bottom", style: { padding: 0 }, className: `${clsPrefix}-popover-wrapper` },
            React.createElement("div", { className: classNames(clsPrefix, `${clsPrefix}-mini`) },
                React.createElement("img", { src: personalPhotoUrl, className: `${clsPrefix}-avatar` }),
                React.createElement("div", null, showName || workNo))));
    }
    return (React.createElement(CnListItem, { className: clsPrefix, title: `${name}${nickName ? `(${nickName})` : ''}  ${workNo}`, media: React.createElement("img", { src: personalPhotoUrl, className: `${clsPrefix}-avatar` }), subTitle: department }));
};
export default CnEmployeeItem;
